export const popoverOptions = [
  'Aug 26, 2025      11:00AM - 11:15 AM',
  'Aug 27, 2025      11:00AM - 11:15 AM',
  'Aug 28, 2025      11:00AM - 11:15 AM'
]
export const paginationOptions = [
  { label: '5 per page', value: 5 },
  { label: '10 per page', value: 10 },
  { label: '20 per page', value: 20 },
  { label: '50 per page', value: 50 },
  { label: '100 per page', value: 100 }
]
export const meetingTypeOptions = [
  { label: 'Follow-up', value: 'Follow-up', color: '#20A7C1' },
  { label: 'Check-up', value: 'Check-up', color: '#5587BC' },
  { label: 'General', value: 'General', color: '#CC8265' },
  { label: 'Initial Consultation', value: 'Initial Consultation', color: '#B665CC' },
]
export const sortOptions = [
  // { label: 'Date Created (Newest First)', value: 'create-desc' },
  // { label: 'Date Created (Oldest First)', value: 'create-asc' },
  { label: 'Due Date (Soonest First)', value: 'due-desc' },
  { label: 'Due Date (Latest First)', value: 'due-asc' },


];
export const patientsList = [
  {
    id: 1,
    name: "John Martinez",
    email: "john.martinez@gmail.com",
    
  },
  {
    id: 2,
    name: "Sarah Thompson",
    email: "sarah.thompson@gmail.com",
  },
  {
    id: 3,
    name: "David Nguyen",
    email: "david.nguyen@gmail.com",
  },
  {
    id: 4,
    name: "Emily Davis",
    email: "emily.davis@gmail.com",
  },
  {
    id: 5,
    name: "Michael Robinson",
    email: "michael.robinson@gmail.com",
  },
  {
    id: 6,
    name: "Jessica Patel",
    email: "jessica.patel@gmail.com",
  },
  {
    id: 7,
    name: "Brian Wilson",
    email: "brian.wilson@gmail.com",
  },
  {
    id: 8,
    name: "Olivia Garcia",
    email: "olivia.garcia@gmail.com",
  },
  {
    id: 9,
    name: "Kevin Johnson",
    email: "kevin.johnson@gmail.com",
  },
  {
    id: 10,
    name: "Amanda Lee",
    email: "amanda.lee@gmail.com",
  }
]
export const durationOptions = [
  { label: '15', value: '15' },
  { label: '30', value: '30' },
  { label: '45', value: '45' },
  { label: '60', value: '60' },
  { label: '90', value: '90' },
  { label: '120', value: '120' }
]

export function getTimeOptions(duration = 15) {
  const normalizedDuration = Number(duration);
  const step = Number.isFinite(normalizedDuration) && normalizedDuration > 0
    ? normalizedDuration
    : 15;
  const options = [];
  const startMinutes = 0;
  const endMinutes = 24 * 60 - 1;

  for (let minutes = startMinutes; minutes <= endMinutes; minutes += step) {
    const hour24 = Math.floor(minutes / 60);
    const minute = minutes % 60;
    const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
    const meridiem = hour24 >= 12 ? 'pm' : 'am';
    const minuteText = String(minute).padStart(2, '0');
    const hourText = String(hour12).padStart(2, '0');
    const label = `${hourText}:${minuteText}${meridiem}`;
    options.push({ label, value: label });
  }

  return options;
}

export const timeOptions = getTimeOptions();
export const suggestedTimes = [
  { id: 1, date: "2025-09-24", start_time: "01:00pm", end_time: "01:30pm" },
  { id: 2, date: "2025-09-25", start_time: "02:30pm", end_time: "03:00pm" },
  { id: 3, date: "2025-09-26", start_time: "09:30am", end_time: "10:00am" },
]
export const locationsList = [
  {
    id: 1,
    name: "3521 Leonard Ct, Santa Clara, CA 95054",
    email: "https://zoom.us/j/83910239483",
  },
  {
    id: 2,
    name: "3100 N First St, San Jose, CA 95134",
    email: "https://zoom.us/j/83910239482",
  },
  // {
  //   id: 3,
  //   name: "Room 103",
  //   email: "3100 N First St, San Jose, CA 95134",
  // },
]
export const providersList = [
  {
    id: 1,
    name: "Dr. Irene Hoffman",
    email: "irene.hoffman@gmail.com",
  },
  {
    id: 2,
    name: "Dr. Harold Kimura",
    email: "harold.kimura@gmail.com",
  },
]

export const taskTableList = [
  {
    id: 1,
    checked: 'uncheck',
    title: 'Review lab results for lipid panel',
    description: 'Review lab results for lipid panel',
    date: 'Thu, Sep 25, 10am',
  },
  {
    id: 2,
    checked: 'checked',
    title: 'Sign off on refill request for Synthroid',
    description: 'Sign off on refill request for Synthroid',
    date: 'Mon, Sep 29, 10am',
  },
  {
    id: 3,
    checked: 'uncheck',
    title: 'Approve new patient intake form',
    description: 'Approve new patient intake form',
    date: 'Tue, Sep 30, 10am',
  },
  {
    id: 4,
    checked: 'checked',
    title: 'Review PHQ-9 scores from last week',
    description: 'Review PHQ-9 scores from last week',
    date: 'Thu, Oct 2, 11am',
  },
  {
    id: 5,
    checked: 'uncheck',
    title: 'Complete charting for yesterday’s appointments',
    description: 'Complete charting for yesterday’s appointments',
    date: 'Fri, Oct 3, 3pm',
  },
  {
    id: 6,
    checked: 'checked',
    title: 'Call pharmacy to clarify inhaler prescription',
    description: 'Call pharmacy to clarify inhaler prescription',
    date: 'Tue, Oct 7, 10am',
  },
  {
    id:7,
    checked: 'uncheck',
    title: 'Review blood pressure logs submitted in portal',
    description: 'Review blood pressure logs submitted in portal',
    date: 'Fri, Oct 10, 10am',
  },
  {
    id:8,
    checked: 'uncheck',
    title: 'Sign off on updated family history form',
    description: 'Sign off on updated family history form',
    date: 'Tue, Oct 14, 10am',
  },
  {
    id:9,
    checked: 'uncheck',
    title: 'Review dizziness log and determine next steps',
    description: 'Review dizziness log and determine next steps',
    date: 'Thu, Oct 16, 10am',
  },
  {
    id:10,
    checked: 'uncheck',
    title: 'Prepare counseling session summary notes',
    description: 'Prepare counseling session summary notes',
    date: 'Tue, Oct 21, 10am',
  },
]

export const patientTaskTableList = [
  {
    id: 1,
    checked: 'checked',
    title: 'Update medication list after lipid panel',
    description: 'Update medication list after lipid panel',
    date: 'Wed, Sep 24, 10am',
    patientName: 'John Martinez',
  },
  {
    id: 2,
    checked: 'uncheck',
    title: 'Record home blood pressure readings',
    description: 'Record home blood pressure readings',
    date: 'Thu, Sep 25, 10am',
    patientName: 'John Martinez',
  },
  {
    id: 3,
    checked: 'checked',
    title: 'Upload thyroid ultrasound report',
    description: 'Upload thyroid ultrasound report',
    date: 'Fri, Sep 26, 10am',
    patientName: 'Sarah Thompson',
  },
  {
    id: 4,
    checked: 'uncheck',
    title: 'Confirm refill request for Synthroid',
    description: 'Confirm refill request for Synthroid',
    date: 'Mon, Sep 29, 10am',
    patientName: 'Sarah Thompson',
  },
  {
    id: 5,
    checked: 'checked',
    title: 'Log blood sugar readings in portal',
    description: 'Log blood sugar readings in portal',
    date: 'Tue, Sep 30, 10am',
    patientName: 'David Nguyen',
  },
  {
    id: 6,
    checked: 'uncheck',
    title: 'Record home blood pressure readings',
    description: 'Record home blood pressure readings',
    date: 'Wed, Oct 1, 10am',
    patientName: 'David Nguyen',
  },
  {
    id: 7,
    checked: 'uncheck',
    title: 'Complete depression inventory questionnaire',
    description: 'Complete depression inventory questionnaire',
    date: 'Thu, Oct 2, 10am',
    patientName: 'Emily Davis',
  },
  {
    id: 8,
    checked: 'uncheck',
    title: 'Submit therapy progress journal',
    description: 'Submit therapy progress journal',
    date: 'Fri, Oct 3, 10am',
    patientName: 'Emily Davis',
  },
  {
    id: 9,
    checked: 'uncheck',
    title: 'Upload peak flow meter readings',
    description: 'Upload peak flow meter readings',
    date: 'Mon, Oct 6, 10am',
    patientName: 'Michael Robinson',
  },
  {
    id: 10,
    checked: 'uncheck',
    title: 'Reorder inhaler',
    description: 'Reorder inhaler',
    date: 'Tue, Oct 7, 10am',
    patientName: 'Michael Robinson',
  },
  {
    id: 11,
    checked: 'uncheck',
    title: 'Fill out anxiety screening form',
    description: 'Fill out anxiety screening form',
    date: 'Wed, Oct 8, 10am',
    patientName: 'Jessica Patel',
  },
  {
    id: 12,
    checked: 'uncheck',
    title: 'Schedule therapy session',
    description: 'Schedule therapy session',
    date: 'Thu, Oct 9, 10am',
    patientName: 'Jessica Patel',
  },
  {
    id: 13,
    checked: 'uncheck',
    title: 'Record home blood pressure readings',
    description: 'Record home blood pressure readings',
    date: 'Fri, Oct 10, 10am',
    patientName: 'Brian Wilson',
  },
  {
    id: 14,
    checked: 'uncheck',
    title: 'Confirm refill of Lisinopril',
    description: 'Confirm refill of Lisinopril',
    date: 'Mon, Oct 13, 10am',
    patientName: 'Brian Wilson',
  },
  {
    id: 15,
    checked: 'uncheck',
    title: 'Submit updated family history form',
    description: 'Submit updated family history form',
    date: 'Tue, Oct 14, 10am',
    patientName: 'Olivia Garcia',
  },
  {
    id: 16,
    checked: 'uncheck',
    title: 'Confirm pharmacy for prescription refill',
    description: 'Confirm pharmacy for prescription refill',
    date: 'Wed, Oct 15, 10am',
    patientName: 'Olivia Garcia',
  },
  {
    id: 17,
    checked: 'uncheck',
    title: 'Track dizziness episodes',
    description: 'Track dizziness episodes',
    date: 'Thu, Oct 16, 10am',
    patientName: 'Kevin Johnson',
  },
  {
    id: 18,
    checked: 'uncheck',
    title: 'Record home blood pressure readings',
    description: 'Record home blood pressure readings',
    date: 'Fri, Oct 17, 10am',
    patientName: 'Kevin Johnson',
  },
  {
    id: 19,
    checked: 'uncheck',
    title: 'Complete side effects tracking form',
    description: 'Complete side effects tracking form',
    date: 'Mon, Oct 20, 10am',
    patientName: 'Amanda Lee',
  },
  {
    id: 20,
    checked: 'uncheck',
    title: 'Schedule next counseling session',
    description: 'Schedule next counseling session',
    date: 'Tue, Oct 21, 10am',
    patientName: 'Amanda Lee',
  },
]

export const fakeMeetingRequestList = [
  {
    id: 1,
    patientName: "Isabella Russo",
    title: "Cardiology Follow-up",
    date: "2026-10-06T10:00:00",
    participants: ["Isabella Russo", "Dr. Laura Bennett"],
    meetingType: "Follow-up",
    location: "In-person",
    meetingUrl: "",
    status: "Available",
    action: ""
  },
  {
    id: 2,
    patientName: "Jamal Anderson",
    title: "Lab Results Review",
    date: "2026-10-07T10:00:00",
    participants: ["Isabella Russo", "Dr. Laura Bennett"],
    meetingType: "Check-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/83910239483",
    status: "Conflict",
    action: ""
  },
  {
    id: 3,
    patientName: "Trevor Banks",
    title: "Endocrinology Visit",
    date: "2026-10-08T10:00:00",
    participants: ["Trevor Banks", "Dr. Eric Chen"],
    meetingType: "General",
    location: "In-person",
    meetingUrl: "",
    status: "Available",
    action: ""
  },
  // {
  //   id: 4,
  //   patientName: "Aria Lopez",
  //   title: "Diabetes Management",
  //   date: "2026-10-09T10:00:00",
  //   participants: ["Aria Lopez", "Dr. Priya Mehta"],
  //   meetingType: "Follow-up",
  //   location: "In-person",
  //   meetingUrl: "",
  //   status: "Conflict",
  //   action: ""
  // },
  // {
  //   id: 5,
  //   patientName: "Sienna Carter",
  //   title: "Nutrition Counseling",
  //   date: "2026-10-10T10:00:00",
  //   participants: ["Sienna Carter", "Dr. Priya Mehta"],
  //   meetingType: "Initial Consultation",
  //   location: "Online",
  //   meetingUrl: "https://zoom.us/j/48102736498",
  //   status: "Available",
  //   action: ""
  // },
  // {
  //   id: 6,
  //   patientName: "Camille Dubois",
  //   title: "Psychiatry Follow-up",
  //   date: "2026-10-13T10:00:00",
  //   participants: ["Camille Dubois", "Dr. Anthony Ruiz"],
  //   meetingType: "Follow-up",
  //   location: "Online",
  //   meetingUrl: "https://zoom.us/j/30294817264",
  //   status: "Conflict",
  //   action: ""
  // },
];

export const fakeMeetingRequestListCalendar = [
  {
    id: 1,
    start: "2025-09-24T17:00:00.000Z",
    end: "2025-09-24T18:00:00.000Z",
    backgroundColor: "#20A7C1",
    title: "Follow-up (J. Martinez)",
    textColor: "#fff",
    meetingType: "Follow-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 1,
      first_name: "John",
      last_name: "Martinez"
    }
  },
  {
    id: 2,
    start: "2025-09-30T17:00:00.000Z",
    end: "2025-09-30T18:00:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (J. Martinez)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/83910239483",
    patient: {
      id: 1,
      first_name: "John",
      last_name: "Martinez"
    }
  },
  {
    id: 3,
    start: "2025-09-25T18:00:00.000Z",
    end: "2025-09-25T19:00:00.000Z",
    backgroundColor: "#CC8265",
    title: "General (S. Thompson)",
    textColor: "#fff",
    meetingType: "General",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 2,
      first_name: "Sarah",
      last_name: "Thompson"
    }
  },
  {
    id: 4,
    start: "2025-09-29T23:00:00.000Z",
    end: "2025-09-30T00:00:00.000Z",
    backgroundColor: "#20A7C1",
    title: "Follow-up (D. Nguyen)",
    textColor: "#fff",
    meetingType: "Follow-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 3,
      first_name: "David",
      last_name: "Nguyen"
    }
  },
  {
    id: 5,
    start: "2025-10-02T23:00:00.000Z",
    end: "2025-10-03T00:00:00.000Z",
    backgroundColor: "#B665CC",
    title: "Initial Consultation (D. Nguyen)",
    textColor: "#fff",
    meetingType: "Initial Consultation",
    location: "Online",
    meetingUrl: "https://zoom.us/j/48102736498",
    patient: {
      id: 3,
      first_name: "David",
      last_name: "Nguyen"
    }
  },
  {
    id: 6,
    start: "2025-09-26T23:00:00.000Z",
    end: "2025-09-27T00:00:00.000Z",
    backgroundColor: "#20A7C1",
    title: "Follow-up (E. Davis)",
    textColor: "#fff",
    meetingType: "Follow-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/30294817264",
    patient: {
      id: 4,
      first_name: "Emily",
      last_name: "Davis"
    }
  },
  {
    id: 7,
    start: "2025-10-01T20:00:00.000Z",
    end: "2025-10-01T21:00:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (M. Robinson)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 5,
      first_name: "Michael",
      last_name: "Robinson"
    }
  },
  {
    id: 8,
    start: "2025-09-29T17:30:00.000Z",
    end: "2025-09-29T18:30:00.000Z",
    backgroundColor: "#CC8265",
    title: "General (J. Patel)",
    textColor: "#fff",
    meetingType: "General",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 6,
      first_name: "Jessica",
      last_name: "Patel"
    }
  },
  {
    id: 9,
    start: "2025-10-03T16:00:00.000Z",
    end: "2025-10-03T17:00:00.000Z",
    backgroundColor: "#20A7C1",
    title: "Follow-up (B. Wilson)",
    textColor: "#fff",
    meetingType: "Follow-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/57492038475",
    patient: {
      id: 7,
      first_name: "Brian",
      last_name: "Wilson"
    }
  },
  {
    id: 10,
    start: "2025-09-30T21:30:00.000Z",
    end: "2025-09-30T22:30:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (O. Garcia)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 8,
      first_name: "Olivia",
      last_name: "Garcia"
    }
  },

  {
    id: 11,
    start: "2025-09-24T18:30:00.000Z",
    end: "2025-09-24T19:30:00.000Z",
    backgroundColor: "#CC8265",
    title: "General (K. Johnson)",
    textColor: "#fff",
    meetingType: "General",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 9,
      first_name: "Kevin",
      last_name: "Johnson"
    }
  },
  {
    id: 12,
    start: "2025-10-02T22:00:00.000Z",
    end: "2025-10-02T23:00:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (K. Johnson)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/92038472034",
    patient: {
      id: 9,
      first_name: "Kevin",
      last_name: "Johnson"
    }
  },
  {
    id: 13,
    start: "2025-09-25T20:30:00.000Z",
    end: "2025-09-25T21:30:00.000Z",
    backgroundColor: "#CC8265",
    title: "General (A. Lee)",
    textColor: "#fff",
    meetingType: "General",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 10,
      first_name: "Amanda",
      last_name: "Lee"
    }
  },
  {
    id: 14,
    start: "2025-09-24T18:00:00.000Z",
    end: "2025-09-24T19:00:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (E. Brooks)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 11,
      first_name: "Ethan",
      last_name: "Brooks"
    }
  },
  {
    id: 15,
    start: "2025-10-01T16:00:00.000Z",
    end: "2025-10-01T17:00:00.000Z",
    backgroundColor: "#B665CC",
    title: "Initial Consultation (E. Brooks)",
    textColor: "#fff",
    meetingType: "Initial Consultation",
    location: "Online",
    meetingUrl: "https://zoom.us/j/10011001100",
    patient: {
      id: 11,
      first_name: "Ethan",
      last_name: "Brooks"
    }
  },
  {
    id: 16,
    start: "2025-09-25T17:00:00.000Z",
    end: "2025-09-25T18:00:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (P. Shah)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 12,
      first_name: "Priya",
      last_name: "Shah"
    }
  },
  {
    id: 17,
    start: "2025-09-29T15:30:00.000Z",
    end: "2025-09-29T16:30:00.000Z",
    backgroundColor: "#20A7C1",
    title: "Follow-up (M. Allen)",
    textColor: "#fff",
    meetingType: "Follow-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 13,
      first_name: "Marcus",
      last_name: "Allen"
    }
  },
  {
    id: 18,
    start: "2025-09-25T22:00:00.000Z",
    end: "2025-09-25T23:00:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (M. Allen)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/10021002100",
    patient: {
      id: 13,
      first_name: "Marcus",
      last_name: "Allen"
    }
  },
  {
    id: 19,
    start: "2025-09-30T20:00:00.000Z",
    end: "2025-09-30T21:00:00.000Z",
    backgroundColor: "#B665CC",
    title: "Initial Consultation (H. Kim)",
    textColor: "#fff",
    meetingType: "Initial Consultation",
    location: "Online",
    meetingUrl: "https://zoom.us/j/10031003100",
    patient: {
      id: 14,
      first_name: "Hannah",
      last_name: "Kim"
    }
  },
  {
    id: 20,
    start: "2025-09-26T22:00:00.000Z",
    end: "2025-09-26T23:00:00.000Z",
    backgroundColor: "#CC8265",
    title: "General (L. Ramirez)",
    textColor: "#fff",
    meetingType: "General",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 15,
      first_name: "Luis",
      last_name: "Ramirez"
    }
  },
  {
    id: 21,
    start: "2025-10-03T16:30:00.000Z",
    end: "2025-10-03T17:30:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (L. Ramirez)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/10041004100",
    patient: {
      id: 15,
      first_name: "Luis",
      last_name: "Ramirez"
    }
  },
  {
    id: 22,
    start: "2025-09-26T18:30:00.000Z",
    end: "2025-09-26T19:30:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (Z. Parker)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 16,
      first_name: "Zoe",
      last_name: "Parker"
    }
  },
  {
    id: 23,
    start: "2025-09-24T23:00:00.000Z",
    end: "2025-09-25T00:00:00.000Z",
    backgroundColor: "#20A7C1",
    title: "Follow-up (G. Ortiz)",
    textColor: "#fff",
    meetingType: "Follow-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 17,
      first_name: "Gabriel",
      last_name: "Ortiz"
    }
  },
  {
    id: 24,
    start: "2025-10-02T17:30:00.000Z",
    end: "2025-10-02T18:30:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (G. Ortiz)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/10051005100",
    patient: {
      id: 17,
      first_name: "Gabriel",
      last_name: "Ortiz"
    }
  },
  {
    id: 25,
    start: "2025-09-30T16:30:00.000Z",
    end: "2025-09-30T17:30:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (M. Johnson)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 18,
      first_name: "Mia",
      last_name: "Johnson"
    }
  },
  {
    id: 26,
    start: "2025-10-01T18:00:00.000Z",
    end: "2025-10-01T19:00:00.000Z",
    backgroundColor: "#20A7C1",
    title: "Follow-up (N. Patel)",
    textColor: "#fff",
    meetingType: "Follow-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/10061006100",
    patient: {
      id: 19,
      first_name: "Noah",
      last_name: "Patel"
    }
  },
  {
    id: 27,
    start: "2025-09-25T22:30:00.000Z",
    end: "2025-09-25T23:30:00.000Z",
    backgroundColor: "#CC8265",
    title: "General (A. Nguyen)",
    textColor: "#fff",
    meetingType: "General",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 20,
      first_name: "Avery",
      last_name: "Nguyen"
    }
  },
  {
    id: 28,
    start: "2025-09-29T22:00:00.000Z",
    end: "2025-09-29T23:00:00.000Z",
    backgroundColor: "#20A7C1",
    title: "Follow-up (D. Rivera)",
    textColor: "#fff",
    meetingType: "Follow-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 21,
      first_name: "Daniel",
      last_name: "Rivera"
    }
  },
  {
    id: 29,
    start: "2025-10-01T20:30:00.000Z",
    end: "2025-10-01T21:30:00.000Z",
    backgroundColor: "#CC8265",
    title: "General (S. Rossi)",
    textColor: "#fff",
    meetingType: "General",
    location: "Online",
    meetingUrl: "https://zoom.us/j/10071007100",
    patient: {
      id: 22,
      first_name: "Sofia",
      last_name: "Rossi"
    }
  },
  {
    id: 30,
    start: "2025-09-24T16:00:00.000Z",
    end: "2025-09-24T17:00:00.000Z",
    backgroundColor: "#B665CC",
    title: "Initial Consultation (J. Green)",
    textColor: "#fff",
    meetingType: "Initial Consultation",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 23,
      first_name: "Jacob",
      last_name: "Green"
    }
  },
  {
    id: 31,
    start: "2025-09-30T22:30:00.000Z",
    end: "2025-09-30T23:30:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (L. Ahmed)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 24,
      first_name: "Layla",
      last_name: "Ahmed"
    }
  },
  {
    id: 32,
    start: "2025-10-03T18:00:00.000Z",
    end: "2025-10-03T19:00:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (O. White)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/10081008100",
    patient: {
      id: 25,
      first_name: "Oliver",
      last_name: "White"
    }
  },
  {
    id: 33,
    start: "2025-09-22T16:00:00.000Z",
    end: "2025-09-22T17:00:00.000Z",
    backgroundColor: "#B665CC",
    title: "Initial Consultation (J. Harper)",
    textColor: "#fff",
    meetingType: "Initial Consultation",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 26,
      first_name: "Julian",
      last_name: "Harper"
    }
  },
  {
    id: 34,
    start: "2025-09-22T16:30:00.000Z",
    end: "2025-09-22T17:00:00.000Z",
    backgroundColor: "#20A7C1",
    title: "Follow-up (A. Lopez)",
    textColor: "#fff",
    meetingType: "Follow-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/777111777",
    patient: {
      id: 27,
      first_name: "Aria",
      last_name: "Lopez"
    }
  },
  {
    id: 35,
    start: "2025-09-22T18:30:00.000Z",
    end: "2025-09-22T19:30:00.000Z",
    backgroundColor: "#CC8265",
    title: "General (D. Clarke)",
    textColor: "#fff",
    meetingType: "General",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 28,
      first_name: "Desmond",
      last_name: "Clarke"
    }
  },
  {
    id: 36,
    start: "2025-09-22T22:00:00.000Z",
    end: "2025-09-22T22:30:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (V. Rossi)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 29,
      first_name: "Valentina",
      last_name: "Rossi"
    }
  },
  {
    id: 37,
    start: "2025-09-22T20:00:00.000Z",
    end: "2025-09-22T21:00:00.000Z",
    backgroundColor: "#CC8265",
    title: "General (T. Banks)",
    textColor: "#fff",
    meetingType: "General",
    location: "Online",
    meetingUrl: "https://zoom.us/j/777222777",
    patient: {
      id: 30,
      first_name: "Trevor",
      last_name: "Banks"
    }
  },
  {
    id: 38,
    start: "2025-09-23T16:00:00.000Z",
    end: "2025-09-23T16:30:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (N. Washington)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 31,
      first_name: "Nia",
      last_name: "Washington"
    }
  },
  {
    id: 39,
    start: "2025-09-23T17:00:00.000Z",
    end: "2025-09-23T18:00:00.000Z",
    backgroundColor: "#B665CC",
    title: "Initial Consultation (E. Mendoza)",
    textColor: "#fff",
    meetingType: "Initial Consultation",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 32,
      first_name: "Elias",
      last_name: "Mendoza"
    }
  },
  {
    id: 40,
    start: "2025-09-23T18:30:00.000Z",
    end: "2025-09-23T19:30:00.000Z",
    backgroundColor: "#5587BC",
    title: "Check-up (A. Silva)",
    textColor: "#fff",
    meetingType: "Check-up",
    location: "Online",
    meetingUrl: "https://zoom.us/j/777333777",
    patient: {
      id: 33,
      first_name: "Aurora",
      last_name: "Silva"
    }
  },
  {
    id: 41,
    start: "2025-09-23T20:00:00.000Z",
    end: "2025-09-23T21:00:00.000Z",
    backgroundColor: "#CC8265",
    title: "General (M. Grayson)",
    textColor: "#fff",
    meetingType: "General",
    location: "In-person",
    meetingUrl: "",
    patient: {
      id: 34,
      first_name: "Matteo",
      last_name: "Grayson"
    }
  },
  {
    id: 42,
    start: "2025-09-23T21:30:00.000Z",
    end: "2025-09-23T22:00:00.000Z",
    backgroundColor: "#B665CC",
    title: "Initial Consultation (S. Carter)",
    textColor: "#fff",
    meetingType: "Initial Consultation",
    location: "Online",
    meetingUrl: "https://zoom.us/j/777444777",
    patient: {
      id: 32,
      first_name: "Sienna",
      last_name: "Carter"
    }
  }
];

export const mapBackgroundColor = (meetingType) => {
  switch (meetingType) {
    case 'Follow-up':
      return '#20A7C1';
    case 'Check-up':
      return '#5587BC';
    case 'General':
      return '#CC8265';
    case 'Initial Consultation':
      return '#B665CC';
    default:
      return '#5587BC';
  }
}


